import React from 'react';
import Icon from '../../../components/AppIcon';

const ChallengeContextCard = ({ challengeData }) => {
  const getGoalTypeLabel = (type) => {
    const labels = {
      fixed: '고정 목표',
      split: '분할 목표',
      thirty_day: '30일 챌린지',
    };
    return labels?.[type] || type;
  };

  const getProgressText = () => {
    if (challengeData?.goalType === 'fixed') {
      return `${challengeData?.currentCount}/${challengeData?.targetCount}회`;
    } else if (challengeData?.goalType === 'split') {
      return `${challengeData?.currentCount}/${challengeData?.targetCount}회 (${challengeData?.splitCount}회씩)`;
    } else if (challengeData?.goalType === 'thirty_day') {
      return `${challengeData?.currentDay}/30일`;
    }
    return '';
  };

  const progressPercentage =
    challengeData?.goalType === 'thirty_day'
      ? (challengeData?.currentDay / 30) * 100
      : (challengeData?.currentCount / challengeData?.targetCount) * 100;

  return (
    <div className="w-full bg-card rounded-lg border border-border p-4 md:p-6 space-y-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1 truncate">
            {challengeData?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground caption">
            {getGoalTypeLabel(challengeData?.goalType)}
          </p>
        </div>
        <div className="flex-shrink-0 px-3 py-1 bg-primary/20 rounded-md">
          <span className="text-xs md:text-sm font-medium text-primary caption">
            {challengeData?.currentProofNumber}번째 증명
          </span>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs md:text-sm text-muted-foreground caption">진행 상황</span>
          <span className="text-xs md:text-sm font-medium text-foreground data-text">
            {getProgressText()}
          </span>
        </div>
        <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary transition-gaming rounded-full"
            style={{
              width: `${Math.min(progressPercentage, 100)}%`,
            }}
          />
        </div>
      </div>
      <div className="flex items-center space-x-2 text-muted-foreground">
        <Icon name="Info" size={16} />
        <span className="text-xs md:text-sm caption">
          이전 증명이 완료되어 새로운 증명을 제출할 수 있습니다
        </span>
      </div>
    </div>
  );
};

export default ChallengeContextCard;